export interface ICompanyGroupModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  name?: string;
  about?: string;
  website?: string;
  created_by?: string;
  updated_by?: string
}

export class CompanyGroupModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  name?: string;
  about?: string;
  website?: string;
  created_by?: string;
  updated_by?: string

  constructor() {
    this.id = null;
    this.is_active = true;
    this.name = null;
    this.about = null;
    this.website = null;
    this.updated_at = null;
    this.created_at = null;
    this.created_by = null;
    this.updated_by = null;
  }
}